import axios from "axios"
import React, {
  useContext,
  useState
} from "react"

import {
  Link,
  useNavigate
} from "react-router-dom"

import Cookies from "js-cookie"

import Ct from "../Ct"

const API = "https://food-backend-9733.onrender.com"

const Login = () => {
  const [data, setData] = useState({
    email: "",
    pwd: ""
  })

  const [msg, setMsg] = useState("")
  const [useOtp, setUseOtp] = useState(false)
  const [otp, setOtp] = useState("")
  const [step, setStep] = useState(1)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()
  const { updfun } = useContext(Ct)

  const goAfterLogin = (res) => {
    Cookies.set(
      "logincrd",
      JSON.stringify(res.data)
    )

    updfun(true)

    if (res.data.user.role === "admin") {
      navigate("/admin")
    } else {
      navigate("/")
    }
  }

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    })
    setMsg("")
  }

  const handleLogin = () => {
    if (!data.email || !data.pwd) {
      setMsg("Please enter email or phone and password")
      return
    }

    setLoading(true)

    axios.post(`${API}/login`, data)
      .then(goAfterLogin)
      .catch(err => {
        setMsg(
          err.response?.data?.msg ||
          "Login failed"
        )
      })
      .finally(() => setLoading(false))
  }

  const sendOtp = () => {
    if (!data.email) {
      setMsg("Enter email or phone to receive OTP")
      return
    }

    setLoading(true)

    axios.post(
      `${API}/send-otp`,
      {
        identifier: data.email
      }
    )
    .then(res => {
      setMsg(res.data.msg)
      setStep(2)
    })
    .catch(err => {
      setMsg(
        err.response?.data?.msg ||
        "OTP send failed"
      )
    })
    .finally(() => setLoading(false))
  }

  const verifyOtp = () => {
    if (!otp) {
      setMsg("Enter OTP")
      return
    }

    setLoading(true)

    axios.post(
      `${API}/verify-otp`,
      {
        identifier: data.email,
        otp
      }
    )
    .then(goAfterLogin)
    .catch(err => {
      setMsg(
        err.response?.data?.msg ||
        "OTP verification failed"
      )
    })
    .finally(() => setLoading(false))
  }

  const switchMode = () => {
    setUseOtp(!useOtp)
    setStep(1)
    setOtp("")
    setMsg("")
  }

  return (
    <main className="auth-page">
      <section className="auth-shell">
        <div className="auth-visual">
          <img
            src="/weekly.jpg"
            alt="Homemade food"
          />

          <div className="auth-visual-overlay">
            <span>Srilekha Vantillu</span>
            <h1>Fresh homemade food, tracked from order to delivery.</h1>
            <p>
              Login to order limited batches, view your cart and follow
              every status update.
            </p>
          </div>
        </div>

        <div className="auth-card">
          <span className="auth-kicker">
            Welcome Back
          </span>

          <h2>Login</h2>

          <p className="auth-subtitle">
            Use password or OTP to continue securely.
          </p>

          <div className="auth-mode-tabs">
            <button
              type="button"
              className={!useOtp ? "active" : ""}
              onClick={() => {
                setUseOtp(false)
                setStep(1)
                setMsg("")
              }}
            >
              Password
            </button>

            <button
              type="button"
              className={useOtp ? "active" : ""}
              onClick={() => {
                setUseOtp(true)
                setStep(1)
                setMsg("")
              }}
            >
              OTP
            </button>
          </div>

          <div className="auth-form">
            <label className="auth-field">
              <span>Email or Phone</span>
              <input
                type="text"
                name="email"
                placeholder="Enter email or phone"
                value={data.email}
                onChange={handleChange}
              />
            </label>

            {!useOtp && (
              <label className="auth-field">
                <span>Password</span>
                <input
                  type="password"
                  name="pwd"
                  placeholder="Enter password"
                  value={data.pwd}
                  onChange={handleChange}
                />
              </label>
            )}

            {useOtp && step === 2 && (
              <label className="auth-field">
                <span>OTP</span>
                <input
                  type="text"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => {
                    setOtp(e.target.value)
                    setMsg("")
                  }}
                />
              </label>
            )}

            {!useOtp && (
              <button
                type="button"
                className="auth-primary-btn"
                onClick={handleLogin}
                disabled={loading}
              >
                {loading ? "Logging in..." : "Login"}
              </button>
            )}

            {useOtp && step === 1 && (
              <button
                type="button"
                className="auth-primary-btn"
                onClick={sendOtp}
                disabled={loading}
              >
                {loading ? "Sending..." : "Send OTP"}
              </button>
            )}

            {useOtp && step === 2 && (
              <button
                type="button"
                className="auth-primary-btn"
                onClick={verifyOtp}
                disabled={loading}
              >
                {loading ? "Verifying..." : "Verify OTP"}
              </button>
            )}

            <button
              type="button"
              className="auth-switch-btn"
              onClick={switchMode}
            >
              {useOtp
                ? "Login with password instead"
                : "Login with OTP instead"}
            </button>

            <p className="auth-inline-link">
              New customer? <Link to="/reg">Create account</Link>
            </p>

            {msg && (
              <p className="auth-message">
                {msg}
              </p>
            )}
          </div>
        </div>
      </section>
    </main>
  )
}

export default Login
